import React from "react";
import { ArrowRight, Heart } from "lucide-react";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/assets";

export const Hero = ({ onDonate }) => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={ASSETS.heroCircle}
          alt="Our HOVSE Foundation community huddle"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/40 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-24 pt-32 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl"
        >
          <div className="inline-flex items-center gap-2 border border-[#C4F542]/40 bg-[#C4F542]/10 px-4 py-2 mb-8">
            <span className="h-2 w-2 bg-[#C4F542] animate-pulse" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#C4F542] font-bold">
              Movement · mentorship · community
            </span>
          </div>

          <h1 className="font-display text-6xl sm:text-7xl lg:text-9xl text-white">
            BUILDING <span className="text-[#C4F542]">CHAMPIONS</span><br />
            FOR LIFE.
          </h1>

          <p className="mt-8 max-w-2xl text-lg sm:text-xl text-zinc-300 leading-relaxed font-body">
            Our HOVSE Foundation empowers young people through movement, mentorship, and
            social-emotional learning (SEL). Together, we're building confident leaders,
            resilient minds, and stronger communities — one child at a time.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#register"
              data-testid="hero-register-btn"
              className="group inline-flex items-center justify-center gap-3 bg-[#C4F542] text-black font-bold uppercase tracking-widest text-sm py-5 px-8 hover:bg-white transition-colors duration-300"
            >
              Reserve a Spot
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <button
              data-testid="hero-donate-btn"
              onClick={onDonate}
              className="group inline-flex items-center justify-center gap-3 border border-white/40 text-white font-bold uppercase tracking-widest text-sm py-5 px-8 hover:border-[#C4F542] hover:text-[#C4F542] transition-colors duration-300"
            >
              <Heart size={16} />
              Donate Now
            </button>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 right-6 md:right-12 hidden md:flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-zinc-400 z-10">
        <span>Scroll</span>
        <div className="h-px w-16 bg-zinc-700" />
      </div>
    </section>
  );
};
